module.exports = __webpack_public_path__ + "static/img/service-customer.492de35b.svg";